import React, { useState } from 'react'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { dTransferCashDesksSetFiltersAC } from "model/dashboardTransferCashDesks/dTransferCashDesksActionCreators";
import { IdTransferCashDesksState, typeTransferCashDesksFilters } from "model/dashboardTransferCashDesks/dTransferCashDesksReducer";
import { NULL_VALUE, SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import DateFilter from 'components/UI/DateFilter/DateFilter';

// Type
export type typeDTransferCashDesksFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const DTransferCashDesksManagementFilters: React.FC<typeDTransferCashDesksFilters> = ( { setOpenFilterBar, setIsActiveFilters } ) => {

    const dispatch = useDispatch()
    const filters = useSelector(( state: { dTransferCashDesks: IdTransferCashDesksState } ) => state.dTransferCashDesks.filters)

    //status SelectBox
    const statusValueList: typeValuesListItem[] = [
        { id: 'выдан', name: "выдан" },
        { id: 'возвращен', name: "возвращен" },

    ]
    const [ statusValue, setStatusValue ] = useState<string | null>(filters.status === null ? NULL_VALUE.id : filters.status!)


    // to Date
    const [ toValue, setToValue ] = useState(filters.date?.from ! ? filters.date.from.substring(0, 10) : '')

    // from Date
    const [ fromValue, setFromValue ] = useState(filters.date?.from ! ? filters.date.from.substring(0, 10) : '')

    const checkIsChangedFiltersHandler = (newFilters: typeTransferCashDesksFilters  ) : boolean => {
        // eslint-disable-next-line eqeqeq
        return !(newFilters.status == filters.status
            // eslint-disable-next-line eqeqeq
            && newFilters.date?.to == filters.date?.to && newFilters.date?.from == filters.date?.from)
    }

    const onSubmitHandler = async ( e: React.FormEvent<HTMLFormElement> ) => {
        e.preventDefault()
        let a = fromValue !== '' ? ( new Date(fromValue).toISOString() ).slice(0, 11) + '00:00:00:00.000+00:00' : null
        let b = toValue !== '' ? ( new Date(toValue).toISOString() ).slice(0, 11) + '23:59:59:99.999+00:00': null
        const newFilters: typeTransferCashDesksFilters = {
          status: statusValue === NULL_VALUE.id? null : statusValue,

            date: ( a === '' && b === '' ) ? null : {
                from: a,
                to: b
            },
        }

if( checkIsChangedFiltersHandler(newFilters)){
    await dispatch(dTransferCashDesksSetFiltersAC(newFilters))
    setIsActiveFilters(true)
}

        setOpenFilterBar(false)
    }

    const onReTransferCashDesksHandler = () => {

        setStatusValue(NULL_VALUE.id)
        setToValue('')
        setFromValue('')
        setIsActiveFilters(false)
        dispatch(dTransferCashDesksSetFiltersAC({status: null, date: null}))
    }

    return (
        <>
            <form onSubmit={( e ) => onSubmitHandler(e)}>
                <div className="flex flex-col gap-4">

                    <div>
                        <SelectBox label={<Trans>Transfer status</Trans>} valuesList={statusValueList}
                                   valueId={statusValue} setIdValue={setStatusValue}/>
                    </div>

                    <DateFilter
                        label={<Trans>Date</Trans>}
                        fromValue={fromValue}
                        setFromValue={setFromValue}
                        toValue={toValue}
                        setToValue={setToValue}
                        maxData={`${(new Date()).getUTCFullYear()}-${((new Date()).getUTCMonth() + 1) > 9 ? (new Date()).getUTCMonth() + 1 : '0'+((new Date()).getUTCMonth() + 1) }-${(new Date()).getUTCDate()}`}
                        minData={'2020-01-01'}
                    />

                    <div className="flex gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={true} type="button"

                                label={<Trans>Clear</Trans>}
                                onClick={() => onReTransferCashDesksHandler()}/>
                        <Button  buttonClassName="w-full" type="submit" label={<Trans>Apply</Trans>}/>
                    </div>

                </div>
            </form>
        </>
    )
}
